import t from '../../../lib/i18n';
import useGTM from "../../../hooks/useGTM";
import { trackFavouritesLoginIntent } from "../../../lib/tracking";

import '../../../styles/components/favourites/login.scss';
import Button from '../../ui/Button';

const FavouritesLoginButton = () => {
  const dispatchGTM = useGTM();

  function onClick () {
    const loginButton = document.querySelector('button[aria-label="Log in"]');
    if (loginButton) {
      loginButton.click();
    }
    dispatchGTM(trackFavouritesLoginIntent());
  }

  return (
    <Button
      className="otrl-jp__favourites-login__button"
      onClick={onClick}
      text={t("favourites.login.button")}
    />
  );
};

export default FavouritesLoginButton;
